import { MutationTree } from 'vuex';
import { AnswersState } from '.';
import {
  SET_ANSWERS,
  UPDATE_ANSWER_IN_CACHE,
  CLEAR_ANSWERS_CACHE,
  ADD_ANSWER,
  SET_CURRENT_ANSWER,
} from './mutationTypes';
import { AnswerListItemViewModel } from '@/features/bots/models/answers/answerListItemViewModel';
import { AnswerViewModel } from '@/features/bots/models/answers/answerViewModel';

export const mutations: MutationTree<AnswersState> = {
  [SET_CURRENT_ANSWER](state, answer: AnswerViewModel) {
    state.currentAnswer = answer;
  },

  [SET_ANSWERS](state, answers: AnswerListItemViewModel[]) {
    state.answers = answers;
  },

  [ADD_ANSWER](state, createdAnswer: AnswerViewModel) {
    state.answers.push({
      id: createdAnswer.id,
      title: createdAnswer.title,
      status: createdAnswer.status,
    });
    state.answers.sort((first, second) => first.title.localeCompare(second.title));
  },

  [UPDATE_ANSWER_IN_CACHE](state, updatedAnswer: AnswerViewModel) {
    const index = state.answers.findIndex((a) => a.id === updatedAnswer.id);
    if (index === -1) {
      return;
    }
    state.answers[index] = {
      id: updatedAnswer.id,
      title: updatedAnswer.title,
      status: updatedAnswer.status,
    };

    state.currentAnswer = updatedAnswer;
    state.answers.sort((first, second) => first.title.localeCompare(second.title));
  },

  [CLEAR_ANSWERS_CACHE](state) {
    state.answers = [];
  },
};
